import { Tablet } from '@/styles/layout';
import styled, { css } from 'styled-components';
import { BANNER_ANIMATION_DELAYS } from '../lib/constants';

const slideUpKeyframes = `
  @keyframes slide-up {
    0% {
      transform: translateY(100px);
      opacity: 0;
    }
    100% {
      transform: translateY(0);
      opacity: 1;
    }
  }
`;

const slideDownKeyframes = `
  @keyframes slide-down {
    0% {
      transform: translateY(0);
      opacity: 1;
    }
    100% {
      transform: translateY(100px);
      opacity: 0;
    }
  }
`;

const slideInRightKeyframes = `
  @keyframes slide-in-right {
    0% {
      transform: translateX(100px);
      opacity: 0;
    }
    100% {
      transform: translateX(0);
      opacity: 1;
    }
  }
`;

const slideOutLeftKeyframes = `
  @keyframes slide-out-left {
    0% {
      transform: translateX(0);
      opacity: 1;
    }
    100% {
      transform: translateX(-100px);
      opacity: 0;
    }
  }
`;

const fadeslideUpKeyframes = `
  @keyframes fadeslideUp {
    0% {
      opacity: 0;
      transform: translateY(-40%);
    }
    6.25% {
      opacity: 1;
      transform: translateY(-50%);
    }
    18.75% {
      opacity: 1;
      transform: translateY(-50%);
    }
    25% {
      opacity: 0;
      transform: translateY(-60%);
    }
    100% {
      opacity: 0;
      transform: translateY(-60%);
    }
  }
`;

export const MainBannerContainer = styled.div`
  width: 100vw;
  background-size: cover;
  background-position: center;
  background-color: white;

  display: flex;
  flex-direction: column;
  align-items: center;
  isolation: isolate;

  ${slideUpKeyframes}
  ${slideDownKeyframes}
  ${slideInRightKeyframes}
  ${slideOutLeftKeyframes}
  ${fadeslideUpKeyframes}

  .slide-up {
    animation: slide-up 0.85s cubic-bezier(0.65, 0, 0.35, 1) both;
  }

  .slide-down {
    animation: slide-down 0.85s cubic-bezier(0.65, 0, 0.35, 1) both;
  }

  .slide-in-right {
    animation: slide-in-right 0.85s cubic-bezier(0.65, 0, 0.35, 1) both;
  }

  .slide-out-left {
    animation: slide-out-left 0.85s cubic-bezier(0.65, 0, 0.35, 1) both;
  }

  .gif {
    position: absolute;
    width: 100%;
    top: 50%;
    animation: fadeslideUp 12s infinite;
  }

  #g2 {
    animation-delay: ${BANNER_ANIMATION_DELAYS.SECOND_BANNER}s;
  }

  #g3 {
    animation-delay: ${BANNER_ANIMATION_DELAYS.THIRD_BANNER}s;
  }

  #g4 {
    animation-delay: ${BANNER_ANIMATION_DELAYS.FOURTH_BANNER}s;
  }

  @media screen and (max-width: ${Tablet}) {
    width: 100%;
    background-color: white;
  }

  ${({ theme }) =>
    !theme.client.isMobile &&
    css`
      &::before {
        position: absolute;
        width: 0;
        height: 0;
        overflow: hidden;
        z-index: -1;

        content: url('https://file.doctornow.co.kr/landing/catchphrase.png')
          url('https://file.doctornow.co.kr/landing/cf-web-main-thumbnail.jpg');
      }
    `}
`;
